import * as React from 'react'
import styled from 'styled-components/macro'
// import {format} from 'date-fns'
// import {useStore} from 'common/useStore'
import {Truck, User} from 'phosphor-react'
import {Checkbox} from 'common/components'

const Container = styled.li`
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 20px;
  border-bottom: 1px solid var(--asc-coolgray);
  cursor: pointer;
  &:hover {
    background: #f0f6e1;
    input {
      border: 1px solid var(--asc-moss);
      box-sizing: border-box;
      box-shadow: 0px 0px 6px 1px var(--secondary);
      border-radius: 5px;
    }
  }
`

const LeftSection = styled.div`
  display: flex;
  margin-top: 5px;
`

const Section = styled.div`
  font-size: 14px;
  width: ${props => (props.section === 'right' ? '30%' : '100%')};
`

const GroupNameAndDates = styled.div`
  display: flex;
  width: 100%;
`

const GroupName = styled.div`
  font-weight: 700;
`

// const GroupDates = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   svg {
//     margin-right: 3px;
//   }
// `

const GroupDescription = styled.div``

const Count = styled.div`
  font-weight: bold;
`

const AssetsCount = styled.div`
  display: flex;
  width: 100%;
  align-content: center;
  align-items: center;
  justify-content: flex-start;
  svg {
    margin: 0px 10px;
    margin-right: 15px;
    min-width: 16px;
    min-height: 16px;
  }
`

const GroupCard = ({group, toggleGroup, selectedGroups}) => {
  const [selected, setSelected] = React.useState(false)
  // const userConfig = useStore(state => state.userConfig)
  // const startDate = group?.StartDate
  //   ? format(new Date(group?.StartDate), userConfig.Date_Format)
  //   : ''
  // const endDate = group?.EndDate
  //   ? format(new Date(group?.EndDate), userConfig.Date_Format)
  //   : ''

  React.useEffect(() => {
    if (selectedGroups.includes(group.idGroup)) {
      setSelected(true)
    } else {
      setSelected(false)
    }
  }, [group.idGroup, selectedGroups])

  return (
    <Container onClick={toggleGroup} data-groupid={group.idGroup}>
      <LeftSection>
        <Checkbox selected={selected} dataCy={'group-select'} />
      </LeftSection>
      <Section>
        <GroupNameAndDates>
          <GroupName>{group?.Group_Name || ''}</GroupName>
        </GroupNameAndDates>
        <GroupDescription>{group?.Group_Description || ''}</GroupDescription>

        {/* {group?.ProjectManager && <div>Manager: {group?.ProjectManager}</div>}
        {(startDate || endDate) && (
          <GroupDates>
            <CalendarBlank size={16} />
            {`${startDate} - ${endDate}`}
          </GroupDates>
        )} */}
      </Section>
      <Section section={'right'}>
        <AssetsCount>
          <Truck size={16} />
          <Count>{group?.Number_Of_Assets}</Count>
        </AssetsCount>

        <AssetsCount>
          <User size={16} />
          <Count>{group?.Number_Of_Users}</Count>
        </AssetsCount>
      </Section>
    </Container>
  )
}
export default GroupCard
